import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PackVerification_ds_scanned_values_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { scannedValues: { Value?: string, Note?: string }[], $top?: number, $skip?: number }): Promise<{ result?: { Value?: string, Note?: string }[], totalCount?: number }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.scannedValues)) {
      missingRequiredInParams.push('\'scannedValues\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PackVerification/datasources/ds_scanned_values_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { scannedValues?: { Value?: string, Note?: string }[], $keys: string[] }): Promise<{ result?: { Value?: string, Note?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PackVerification/datasources/ds_scanned_values_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      scannedValues: { Value?: string, Note?: string }[]    }) {
        if(isNil(inParams.scannedValues)) {
          return true; 
        }
      return false;
    }
}
